$(document).ready(function () {
  $('#label-cv').html('Attach Resume/CV');
  $('#label-cover_letter').html('Attach Cover Letter');
  $('#label-portfolio').html('Attach Portfolio');

  $('input[type="file"]').change(function () {
    var selected_input = $(this).attr('data-name');
    var filePath = $('#' + selected_input).val();

    // If no file was selected, do nothing
    if (!filePath) return;

    // Check if extension is valid
    if (textFileFormat(filePath)) {
      // Check file size
      var file = this.files[0];
      if (file && !checkFileSize(file, 5)) {
        // File is too large
        $('#extension-warning-' + selected_input).html(
          'File too large. Maximum size is 5 MB.'
        );
        $('#label-' + selected_input).html(returnLabelText(selected_input));
        $('#input-file-delete-' + selected_input).css('display', 'none');
        $('#' + selected_input).replaceWith(
          $('#' + selected_input)
            .val('')
            .clone(true)
        );
      } else {
        // File extension & size are valid
        $('#label-' + selected_input).html(formatInputFileName(selected_input));
        $('#input-file-delete-' + selected_input).css(
          'display',
          'inline-block'
        );
        $('#extension-warning-' + selected_input).html('');
      }
    } else {
      // Invalid extension
      $('#extension-warning-' + selected_input).html(
        'Please attach a valid document file.'
      );
      $('#label-' + selected_input).html(returnLabelText(selected_input));
      $('#input-file-delete-' + selected_input).css('display', 'none');
      $('#' + selected_input).replaceWith(
        $('#' + selected_input)
          .val('')
          .clone(true)
      );
    }
  });

  $('.input-file-delete').click(function (event) {
    event.preventDefault();
    var selected_input = $(this).attr('data-name');
    $('#' + selected_input).replaceWith(
      $('#' + selected_input)
        .val('')
        .clone(true)
    );
    $('#label-' + selected_input).html(returnLabelText(selected_input));
    $('#input-file-delete-' + selected_input).css('display', 'none');
    $('#extension-warning-' + selected_input).html('');
  });

  function formatInputFileName(input) {
    //$('#cv').val() vraca C:\fakepath\imefajla
    var name = $('#' + input).val();
    var formattedName = name.slice(12, name.length);
    return formattedName;
  }

  function returnLabelText(input) {
    if (input === 'cv') {
      return 'Attach Resume/CV';
    } else if (input === 'cover_letter') {
      return 'Attach Cover Letter';
    } else if (input === 'portfolio') {
      return 'Attach Portfolio';
    }
  }

  function textFileFormat(filePath) {
    var extensions = ['pdf', 'odt', 'doc', 'docx', 'txt'];
    var extensionOfFile = filePath
      .slice(filePath.lastIndexOf('.') + 1)
      .toLowerCase();
    return extensions.includes(extensionOfFile);
  }

  function checkFileSize(file, maxSizeMB) {
    var maxSize = maxSizeMB * 1024 * 1024;
    return file.size <= maxSize;
  }
});
